module.exports = __webpack_public_path__ + "static/media/instructor-6.a8a36fb3.png";